import { render, staticRenderFns } from "./BreadCrumd.vue?vue&type=template&id=59d0084c&scoped=true"
import script from "./BreadCrumd.vue?vue&type=script&lang=js"
export * from "./BreadCrumd.vue?vue&type=script&lang=js"
import style0 from "./BreadCrumd.vue?vue&type=style&index=0&id=59d0084c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59d0084c",
  null
  
)

export default component.exports